import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFilterComplete } from "src/app/filter-complete/filter-complete";
import { LaboratoryTubeControlEdit } from "src/app/model/laboratory-tubes/laboratory-tubes-edit";


@Component({
  selector: "app-laboratory-tubes-controls-dialog",
  templateUrl: "./laboratory-tubes-controls-dialog.component.html",
  styleUrls: ["./laboratory-tubes-controls-dialog.component.css"],
})
export class LaboratoryTubesControlsDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<LaboratoryTubesControlsDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: LaboratoryTubeControlEdit[]
  ) {

  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close(null);
  }
}
